import { Link } from 'react-router-dom';
import { periodColumn } from 'components/columns';
import type { ListBonus } from 'modules/guarantee/types';
import { TableColumns } from '@ff-it/ui';
import { OverflowContainer } from 'components/OverflowContainer/OverflowContainer';
import { CompanyTitle } from 'modules/core/company/components';
import { TitleContainer } from 'components/TitleContainer';

export * from './BonusForm';
export * from './RateGroups';

export const columns: TableColumns<ListBonus> = [
  {
    content: 'Number',
    key: 'number',
    minWidth: 200,
    sortable: true,
    render: ({ id, number }: ListBonus) => (
      <OverflowContainer title={number}>
        <Link to={`${id}`}>{number}</Link>
      </OverflowContainer>
    ),
  },
  {
    content: 'Title',
    key: 'title',
    width: undefined,
    sortable: true,
  },
  {
    content: 'Partner',
    key: 'partner.title' as any,
    width: undefined,
    sortable: true,
    minWidth: 120,
    cellProps: { className: 'py-1' },

    render: ({ partner }) => <CompanyTitle {...partner} />,
  },
  {
    cellProps: { className: 'py-1' },
    content: 'Type',
    key: '_type',
    render: ({ kind, regularity }) => <TitleContainer title={kind} subtitle={regularity} />,
  },
  periodColumn,
];

export const initialValues = {
  title: '',
  number: '',
  partner: null,
  regularity: null,
  date_from: null,
  date_to: null,
  kind: null,
  terms: '',
  notes: '',
  signature_first_name: '',
  signature_last_name: '',
  attachments: [],
  groups: [],
};
